import { render, staticRenderFns } from "./CustomerSummaryPage.vue?vue&type=template&id=06e943be&scoped=true"
import script from "./CustomerSummaryPage.vue?vue&type=script&lang=js"
export * from "./CustomerSummaryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e943be",
  null
  
)

export default component.exports